import { useGLTF } from '@react-three/drei';

import { MODELS } from './assets';

/** The room the instrument sits in. Static geometry, no interaction. */
export function SetPiece() {
  const { scene } = useGLTF(MODELS.set);
  return <primitive object={scene} receiveShadow />;
}
